import React from "react";
import useStatisticsData from "../Statistics/useStatisticsData.js";
import NutzungHeatmapGrid from "./NutzungHeatmapGrid.jsx";
import NutzungWidget from "./NutzungWidget.jsx";

/** Wochentag×Stunde-Heatmap für den Überblick - liest /nutzung/daten/heatmap
 * und reicht die Rohdaten an die reine Darstellungs-Komponente weiter. */
export default function NutzungHeatmap({filters}) {
    const {data, loading, error} = useStatisticsData("/nutzung/daten/heatmap", filters);
    const rows = Array.isArray(data) ? data : [];
    const hatWerte = rows.some((row) => row.wert > 0);

    return (
        <NutzungWidget
            title="Aktivität nach Wochentag und Stunde"
            help="Zeigt, wann im gewählten Zeitraum am meisten gearbeitet wurde - je dunkler die Kachel, desto mehr Aktivität in dieser Stunde."
            loading={loading}
            error={error}
            empty={!loading && !error && !hatWerte}
            height={260}
        >
            <NutzungHeatmapGrid rows={rows} />
        </NutzungWidget>
    );
}
